import React, { useContext, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Formik } from 'formik'
import { useHistory } from 'react-router-dom'
import { Card, CardBody, CardFooter, CardTitle, Button, Form } from 'reactstrap'
import MainContainer from '../../components/modules/containers/MainContainer'
import VisitForm from '../../components/home/VisitForm'
import { getAll } from '../../api/township'
import { getMembers } from '../../api/member'
import { saveVisit } from '../../api/visit'
import UserContext from '../../store/userContext'
import { validateVisit } from '../../validations/visit'
import { patientHome } from '../../breadcrumRoutes.js'

const NewVisit = () => {
  let initalValues = {
    date: '',
    township_ids: [],
    co_visitors: [],
    type_of_visit: '',
    place_of_visit: '',
    coordination: '',
    program: '',
    m_and_e: '',
    recommendation: '',
    attachment: '',
    project: '',
    region_id: '',
  }
  const [townships, setTownships] = useState([])
  const [members, setMember] = useState([])
  const [loading, setLoading] = useState(false)
  const [attachment, setAttachment] = useState(null)
  const [row, setRow] = useState(0)
  const [col, setCol] = useState(0)
  const [tableData, setTableData] = useState([])
  const { project } = useParams()

  let location = useLocation()
  let history = useHistory()

  let { eachData } = useContext(UserContext)
  const submitData = async (values) => {
    if (project === 'REGION') {
      let searchResult = new URLSearchParams(location.search)
      values.region_id = searchResult.get('region_id')
      values.project = 'REGION'
    } else {
      values.project = project
    }
    values.tableData = JSON.stringify(tableData)
    if (await saveVisit(values, { name: 'attachment', file: attachment })) {
      history.push('/home')
    }
  }

  useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true)
      let params = {}
      if (project === 'REGION') {
        let searchResult = new URLSearchParams(location.search)
        params.region_id = searchResult.get('region_id')
      } else {
        params.project = project
      }
      let responseTownship = await getAll(params)
      setTownships(responseTownship)
      let responseMember = await getMembers()
      setMember(responseMember)
      setLoading(false)
    }
    fetchMyAPI()
  }, [getAll, project, location])

  return (
    <>
      <MainContainer breadcrums={patientHome}>
        {!loading && (
          <Formik
            initialValues={initalValues}
            onSubmit={(values) => submitData(values)}
            validate={(values) => {
              const errors = validateVisit(values)
              return errors
            }}
          >
            {(formik) => (
              <Form onSubmit={formik.handleSubmit}>
                <Card>
                  <CardBody>
                    <CardTitle className="mb-3" tag="h5">
                      Add Visit Data
                    </CardTitle>
                    <VisitForm
                      userData={eachData}
                      townships={townships}
                      formik={formik}
                      members={members}
                      onFileChange={(file) => {
                        setAttachment(file)
                      }}
                      row={row}
                      col={col}
                      tableData={tableData}
                      setRow={setRow}
                      setCol={setCol}
                      setTableData={setTableData}
                    />
                  </CardBody>
                  <CardFooter className="d-flex justify-content-end">
                    <Button color="primary" type="submit">
                      Save
                    </Button>
                  </CardFooter>
                </Card>
              </Form>
            )}
          </Formik>
        )}
      </MainContainer>
    </>
  )
}

export default NewVisit
